
import { initializeApp } from "firebase/app";
import 'firebase/auth';
import 'firebase/database';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './components/App.js';
import './index.css';


// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCRxwLXstj4EQy-6KzUD3CsfjNnfG2ipDs", // find this on the console and replace it locally
  authDomain: "key-change-330221.firebaseapp.com",
  databaseURL: "https://key-change-330221-default-rtdb.firebaseio.com",
  projectId: "key-change-330221",
  storageBucket: "key-change-330221.appspot.com",
  messagingSenderId: "399246401967",
  appId: "1:399246401967:web:7bbacd241eef2ef2e18f5a",
};

// Initialize Firebase
initializeApp(firebaseConfig);

ReactDOM.render(
  <React.StrictMode>
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/js/bootstrap.bundle.min.js" integrity="sha384-ka7Sk0Gln4gmtz2MlQnikT1wXgYsOg+OMhuP+IlRH9sENBO0LRn5q+8nbTov4+1p" crossOrigin="anonymous"></script>
  <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.0/dist/css/bootstrap.min.css" />
    <BrowserRouter>
      <App/>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);